import LocalStorageService from "./LocalStorageService"
/** Authentication namespace
 * @namespace
 */
export const Auth = {

  isLoggedIn: false,
  token: null,
  userName: null,
  refreshToken: null,

  /** Check is user authenticated or not */
  isAuthenticated: function () {

    const authData = LocalStorageService.get('authorizationData');

    if (authData && authData.access) {

      this.isLoggedIn = true;
      this.role = authData.superAdmin;
      this.token = authData.access;
      this.refreshToken = authData.refresh;

      return true;

    } else {
      return false;
    }
  },

  /** 
    * @typedef AuthData
    * @property {boolean} isLoggedIn Is user loged in or not
    * @property {string} token Token
    * @property {string} refreshToken Refresh token
    */

  /** Get authenticated user's data
   * @returns {AuthData}*/

  fillAndGetData: function () {

    const authData = LocalStorageService.get("authorizationData");

    if (authData) {
      this.isLoggedIn = true;
      this.token = authData.access;
      this.refreshToken = authData.refresh;
    }
    return this;
  },

  /** Get authenticated user's data
 * @returns {AuthData}*/

  setAuthData: function (authData) {

    LocalStorageService.set("authorizationData", authData);

    if (authData) {
      this.isLoggedIn = true;
      this.token = authData.access;
      this.refreshToken = authData.refresh;
    } else {
      this.isLoggedIn = false;
      this.token = null;
      this.refreshToken = null;
    }
    return this;
  },

  /** Invalidate user session*/
  invalidateSession: function () {
    LocalStorageService.remove("authorizationData");
    LocalStorageService.remove("role");
    this.isLoggedIn = false;
    this.token = null;
    this.refreshToken = null;
  },

  setRole: function (role) {
    LocalStorageService.set("role", role);
  },

  getRole: function () {
    return LocalStorageService.get('role');
  },

  // TODO change checking logic
  checkPermission: function () {
    return LocalStorageService.get('role');
  }

}